import { render, staticRenderFns } from "./NfeDetails.vue?vue&type=template&id=72432ee7"
import script from "./NfeDetails.vue?vue&type=script&lang=js"
export * from "./NfeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports